import React from 'react';
import urlCheck from '../../utils/urlCheck';
import { openAccountLink } from '../../utils/navigation';

import styles from '../ScreenerHeader/ScreenerHeader.css';

const MobileContactHeader = ({
    changePhoneNumber,
    snapshotView,
    selectedOption
}) =>
    !urlCheck('mobile') && (
        <div
            className={
                snapshotView
                    ? 'snapshot-mobile-open-acct'
                    : 'mobile-open-acct-container'
            }
        >
            <div className="open-acct-text">
                Ready to get started?
                <br />
                <a
                    href={openAccountLink(selectedOption)}
                    id="fund-screener-open-an-account"
                >
                    Open an Account
                </a>
            </div>
            <div className="call-now">
                or call:<br />
                <a
                    href={
                        changePhoneNumber
                            ? 'tel:866-223-4889'
                            : 'tel:866-264-5579'
                    }
                >
                    {changePhoneNumber ? '866-223-4889' : '866-264-5579'}
                </a>
            </div>
            <style jsx>{styles}</style>
        </div>
    );

export default MobileContactHeader;
